import { unwrap } from "@sagot/api-client";
import { useQuery, type UseQueryOptions, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "../../../session/session-provider";
import { useWorkspaceId } from "../../../session/workspace-context";
import type { BillingOverview } from "./api-types";
import { wsKeys } from "./query-keys";

/** How a caller wants the shared overview kept fresh (the sidebar meter polls; pages just read). */
export type BillingOverviewRefresh = Pick<UseQueryOptions<BillingOverview>, "staleTime" | "refetchInterval" | "refetchOnWindowFocus">;

/** `GET /v1/billing/overview`: plan, meters, credits, payment methods (needs `billing.view`). */
export function useBillingOverview(enabled = true, refresh: BillingOverviewRefresh = {}): UseQueryResult<BillingOverview> {
  const api = useApi();
  const wsId = useWorkspaceId();
  return useQuery({ queryKey: wsKeys.billingOverview(wsId), queryFn: () => unwrap(api.GET("/v1/billing/overview")), enabled, ...refresh });
}
